import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from './authStore';

export function ProtectedRoute({ children, roles }) {
  const token = useAuthStore((s) => s.token);
  const usuario = useAuthStore((s) => s.usuario);
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (roles && usuario && !roles.includes(usuario.rol)) {
    return (
      <div className="p-8 text-center text-slate-300">
        <h1 className="text-2xl font-bold text-rose-400">Acceso Denegado</h1>
        <p className="mt-2">No tienes permisos para acceder a esta sección.</p>
      </div>
    );
  }

  return children;
}
